import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import BlogsDetails from "../blogdetails.js";
import BlogSidebar from "../blogSidebar.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

function BlogOrganicCakes() {
  const [showSidebar, setShowSidebar] = useState(false);
  const handleClick = (paths) => {
    window.open(`https://order.wheatbakes.com/onlineorder/`, "_blank");
  };
  return (
    <Container className="blog-page mt-4">
      <Row>
        {/* Sidebar */}
        <Col md={1} className={`blog-sidebar ${showSidebar ? "show" : "hide"}`}>
          <BlogSidebar
            blogs={BlogsDetails}
            closeSidebar={() => setShowSidebar(!showSidebar)}
            active={"celebrate-healthier-with-clean-ingredients"}
          />
        </Col>

        {/* Main Content */}
        <Col md={12} className="blog-content">
          {/* Toggle button for mobile */}
          <div
            onClick={() => setShowSidebar(!showSidebar)}
            className="blogs-sidebar-open mb-3"
          >
            <FontAwesomeIcon
              icon={faBars}
              className="blogs-sidebar-close-icon me-2"
            />
            View Other Blogs
          </div>

          {/* Banner Image */}
          {/* Blog Content */}
          <div class="container row my-4">
              
              <div class="col-lg-6 col-xl-6 col-sm-12 my-2" data-aos="fade-left">
                <h2 className="brown-text-color text-bold-600">
                  Celebrate Healthier with Clean Ingredients
                </h2>
                <h4 className="brown-text-color">Introduction</h4>
                <p className="fw-semibold wheatbakes-para-justify">
                  Celebrations and cakes go hand in hand. But let’s face it—cakes
                  are often loaded with refined sugar, artificial flavors, and
                  preservatives. While they may look tempting, they don’t always
                  align with a healthy lifestyle.
                </p>

                <p className="fw-semibold wheatbakes-para-justify">
                  This is where <b>clean-ingredient cakes </b>step in. With no
                  preservatives, and no artificial additives, they bring the perfect
                  balance of taste, health, and happiness. At <b>WheatBakes</b>,
                  we’re redefining indulgence with cakes that you can enjoy without
                  guilt.
                </p>
              </div>     
              <div class="col-lg-6 col-xl-6 col-sm-12 my-2" data-aos="fade-right">
                <img
                  src={"/images/home/slicecake.png"} // Replace with your banner image path
                  alt="Natural Cakes"
                  className="img-fluid rounded w-100 "
                />
              </div>         
          </div>
         
          <div>
          <h4 className="brown-text-color">
            1. What Makes Healthy Cakes Different?
          </h4>
          <p>
            Our cakes are crafted with natural, high-quality ingredients sourced
            responsibly. Instead of relying on refined sugar, chemical
            preservatives, or artificial enhancers, we use:
          </p>
          <ul>
            <li>
              <b>🌱 Whole wheat and millet-based flours</b>
            </li>
            <li>
              <b>🍯 Natural sweeteners like jaggery (no white sugar)</b>
            </li>
            <li>
              <b>🥥 Fresh, chemical-free fruits &amp; nuts</b>
            </li>
          </ul>
          <p>This means every bite is pure, safe, and nourishing.</p>
          </div>
        
          <h4 className="brown-text-color">
            2. Why Choose Clean-Ingredient Cakes?
          </h4>
          <p>
            Switching to guilt-free cakes offers benefits beyond just taste:
          </p>
          <ul>
            <li>
              <b>No Preservatives </b>→ Baked fresh, without chemicals that harm
              your health.
            </li>
            <li>
              <b>No Artificial Colors or Flavors </b>→ Only real, natural
              ingredients.
            </li>
            <li>
              <b>Wholesome & Nutritious</b> → Made with whole grains, nuts,
              seeds, and fruits.
            </li>
            <li>
              <b>Safe for All Ages</b> → Parents can confidently serve them to
              children.
            </li>
          </ul>

          <h4 className="brown-text-color">
            3. Guilt-Free Cakes for Every Celebration
          </h4>
          <p className="wheatbakes-para-justify">
            Whether it’s a birthday, wedding, anniversary, or just a weekend
            treat, natural cakes bring a touch of wellness to every occasion.
            Imagine cutting into a beautifully decorated cake that’s not only
            delicious but also made without harmful ingredients—that’s the magic
            of <b>healthy baking.</b>
          </p>

          <h4 className="brown-text-color">4. The WheatBakes Way</h4>
          <p>
            At WheatBakes, we believe dessert should never come with compromise.
            That’s why our cakes are:
          </p>
          <ul>
            <li>Eggless and wholesome – for everyone to enjoy.</li>
            <li>Freshly baked daily – no preservatives, no chemicals.</li>
            <li>
              Naturally sweetened – with healthier alternatives like jaggery,
              not refined sugar.
            </li>
            <li>
              Customizable – perfect for birthdays, weddings, and bulk orders.
            </li>
          </ul>
          <p>
            Every recipe is designed to bring joy without sacrificing health.
          </p>

          <h4 className="brown-text-color">
            5. Final Slice: Sweetness Without the Guilt
          </h4>
          <p className="wheatbakes-para-justify">
            Desserts should be about happiness, not worry. With no
            preservatives, and only natural ingredients, 
            <b> clean-label cakes </b>are changing the way we celebrate.
            At WheatBakes, we’re proud to craft cakes that let you indulge
            freely, celebrate joyfully, and live healthily. Because true
            sweetness is the one that cares for your well-being.
          </p>

          <div className="my-5 text-center">
            <button
              className="wheatbakes-btn"
              onClick={() => handleClick("onlineorder")}
            >
              EAT HEALTHY CAKES NOW
            </button>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default BlogOrganicCakes;
